// extracted by mini-css-extract-plugin
module.exports = {"container":"styles_container__K2BCI","fadeInOut":"styles_fadeInOut__R2c4m","loader":"styles_loader__VvcMW"};